/**
 * GiftItem component is used by other module as a resuable which  returns the ui for Gift Item
 *
 * @module views/components/GiftItem
 * @memberof -Common
 */
import './GiftItem.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Image from '@ulta/core/components/Image/Image';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Text from '@ulta/core/components/Text/Text';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a GiftTitle component
 * Renders Text component as a Text input
 * @method
 * @param {object} props - React properties passed from composition
 * @returns GiftTitle
 */
export const GiftTitle = function( props ){
  const {
    title
  } = props;
  return (
    title &&
      <div className='GiftItem__title'>
        <Text
          htmlTag={ title.htmlTag }
          textStyle={ title.textStyle }
          color={ title.color }
          textAlign={ title.textAlign }
        >{ title.text }
        </Text>
      </div>
  );
};

/**
 * Represents a GiftItem component
 *
 * @method
 * @param {GiftItemProps} props - React properties passed from composition
 * @returns GiftItem
 */
export const GiftItem = function( props ){

  const {
    image,
    eyebrow,
    title,
    description,
    linkAction
  } = props;

  if( !image || !description ){
    return null;
  }

  return (
    <div className='GiftItem'>
      <div className='GiftItem__image'>
        <Image
          { ...spreadProps( { metaData: image.metaData } ) }
          src={ image.imageUrl }
          alt={ image.altText }
          aspectRatio={ '1:1' }
        />
      </div>
      <div className='GiftItem__textContent'>
        { eyebrow &&
          <div className='GiftItem__eyebrow'>
            <Text
              htmlTag='span'
              textStyle='eyebrow'
            >
              { eyebrow }
            </Text>
          </div>
        }
        { title &&
          <div className='GiftItem__DesktopTitle'>
            <GiftTitle title={ title } />
          </div>
        }
        <div className='GiftItem__subtitle'>
          <Text
            htmlTag='p'
            textStyle='body-2'
            color='neutral-800'
          >
            { description }
          </Text>
        </div>
        { linkAction && linkAction.label &&
          <div className='GiftItem__linkAction'>
            <Link_Huge
              action={ linkAction }
              target='_self'
              withHover
            >
              { linkAction.label }
            </Link_Huge>
          </div>
        }
      </div>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef GiftItemProps
 * @type {object}
 * @property {string} tile - Set the title for the gift
 * @property {object} image - Set the top image
 * @property {string} eyebrow - set the eybrow
 * @property {string} description - set the subtitle for the gift item
 * @property {object} linkAction - Sets the first link action
 */
export const propTypes = {
  title: PropTypes.object,
  image: PropTypes.object,
  eyebrow: PropTypes.string,
  description: PropTypes.string,
  linkAction: PropTypes.object
};

GiftItem.propTypes = propTypes;

export default GiftItem;
